import React, { useState } from 'react';

interface MailImage {
    title: string;
    src: string;
}

const Mails: React.FC = () => {
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    const images: MailImage[] = [
        { title: 'Welcome Mail', src: '/email/welcome.svg' },
        { title: 'No Activity Mail', src: '/email/no_activity.svg' },
        { title: 'Wait List Mail', src: '/email/waitlist.svg' },
        { title: 'Thanks for Intrest', src: '/email/thanks4interest.svg' },
        { title: 'Announcement 1', src: '/email/annoucement_1.svg' },
        { title: 'Announcement 2', src: '/email/announcement_2.svg' },
    ];

    const openImage = (src: string): void => {
        setSelectedImage(src);
    };

    const closeImage = (): void => {
        setSelectedImage(null);
    };

    return (
        <>
            {/* Top Heading */}
            <div className="mt-8 mb-4">
                <h1 className="text-3xl font-bold">All Mail Template</h1>
            </div>

            {/* Gallery Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 p-6">
                {images.map((img, index) => (
                    <div
                        key={index}
                        className="cursor-pointer text-center my-3"
                        onClick={() => openImage(img.src)}
                    >
                        <div className="w-[300px] h-[200px] mx-auto overflow-hidden rounded-md shadow-sm">
                            <img
                                src={img.src}
                                alt={img.title}
                                className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                            />
                        </div>
                        <h2 className="my-2 text-lg font-bold">{img.title}</h2>
                    </div>
                ))}
            </div>

            {/* Modal */}
            {selectedImage && (
                <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
                    <div className="relative">
                        <img
                            src={selectedImage}
                            alt="Full View"
                            className="max-h-[90vh] max-w-[90vw] rounded-md shadow-lg"
                        />
                        <button
                            onClick={closeImage}
                            className="absolute top-2 right-2 text-white text-2xl bg-black bg-opacity-60 rounded-full px-3 py-1 hover:bg-opacity-90"
                        >
                            ✕
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default Mails;
